import { render, staticRenderFns } from "./atmosphere.vue?vue&type=template&id=32c0b1f4&scoped=true&"
import script from "./atmosphere.vue?vue&type=script&lang=js&"
export * from "./atmosphere.vue?vue&type=script&lang=js&"
import style0 from "./atmosphere.vue?vue&type=style&index=0&id=32c0b1f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c0b1f4",
  null
  
)

export default component.exports